import React from "react";
import * as d3 from "d3";
import ClassNames from "classnames";

import ExternalLink from '../assets/Asset_Link_icon.png';

const toSlug = k => k.replace(/[.\s]/g, "-")

export default class Nodes extends React.Component {
  constructor(props) {
    super(props);
    this.state = { 
      hoverNode: null,
      externalLinkPosition: { x: 0, y: 0 }
    };
  }

  static defaultProps = {
    showBox: true,
    showLabel: true
  };

  mouseEnter(node) {
    const width = d3.select(this.node)
      .selectAll("g.node-id-" + toSlug(node.key) + " tspan.node-data-key")
      .node()
      .getComputedTextLength()
    this.setState({ 
      hoverNode: node.key,
      externalLinkPosition: {
        x: node.side === "after" 
          ? node.x0 - width - 19
          : node.x0 + node.textX + width + 6,
        y: node.y0 + 5
      }
    });
    d3.selectAll("g.node-id-" + toSlug(node.key)).each(function() {
      this.parentNode.appendChild(this);
      d3.select(this).classed("hovered", true);
    });
  }

  mouseLeave(node) {
    d3.selectAll("g.node-id-" + toSlug(node.key)).each(function() {
      d3.select(this).classed("hovered", false);
    });
    this.setState({ hoverNode: null });
  }

  render() {
    const { nodes, showLabel, color, align, formatPercentage, dialogLeavingWTSite } = this.props;
    const { externalLinkPosition } = this.state

    return (
      <g ref={node => this.node = node}>
        {nodes.map((node, i) => {
          const left = align === "left";
          if (node.value === 0) {
            return null;
          }
          const url = node.data.values[0].fundPageURL;
          const label = 
            (<text
              fill={node.textColor}
              textAnchor={left ? "start" : "end"}
              className={ClassNames({
                "fade-out": node.textFadeOut,
                "hidden": !showLabel || (!node.showLabel && this.state.hoverNode !== node.key)
              })}
            >
              <tspan
                className={ClassNames("node-data-key", { "link": !!url })}
                x={0}
                dx={5 * (left ? 1 : -1)}
                dy={node.textYOffset}
                style={{ fontWeight: 700 }}
                onClick={() => {
                  if(url) dialogLeavingWTSite(url);
                }}>
                <tspan className="flows-link-no-pdf">{node.data.key}</tspan>
                <a className="flows-link-pdf-only" href={url}>{node.data.key}</a>
              </tspan>
              <tspan
                dy={node.labelYOffset}
                x={node.percentageX + node.percentageInsidePosition}
                dx={node.labelXOffset * (left ? 1 : -1)}
                className={ClassNames({
                  inside: node.percentageInsideClass,
                  smallText: true
                })}
              >
                {formatPercentage(node.percentage)}
              </tspan>
            </text>);

          return (
            <g
              className={"node node-id-" + toSlug(node.key)}
              key={node.key + i}
              transform={`translate(${node.x0},${node.y0})`}
              style={{ opacity: node.opacity }}
              onMouseEnter={() => {
                this.mouseEnter(node);
              }}
              onMouseLeave={() => {
                this.mouseLeave(node);
              }}
            >
              <rect
                width={node.x1 - node.x0}
                height={node.y1 - node.y0}
                fill={color}
              />
              <g transform={`translate(${node.tooltipX},${node.tooltipY})`}>
                <text className={ClassNames("flows-tooltip", {
                  [align]: true,
                  "hidden": !showLabel || (this.state.hoverNode !== node.key)
                })}>{node.data.values[0].name}</text>
              </g>
              <g transform={`translate(${node.textX},0)`}>
                {label}
              </g>
            </g>
          );
        })}
        {this.state.hoverNode
          ? <image 
            x={externalLinkPosition.x}
            y={externalLinkPosition.y}
            href={ExternalLink} 
            alt="External" />
          : null}
      </g>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Flows/Nodes.js